import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Header from "../../../shared/layout/Header";
import { CartProvider } from "../../cart/context/CartContext";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import Contact from "../components/Contact";

const ContactUsPage = () => {
    return (
        <CartProvider>
            <ColorInit color={'bigmall'} />
            <ScrollToTop smooth color="#ef253c" />
            <Header />
            <div className="container container-lg">
            <Contact />
            </div>
            <Footer />
            <BottomFooter />
        </CartProvider>
    );
}

export default ContactUsPage;